import { render, staticRenderFns } from "./BazarLogin.vue?vue&type=template&id=5d9b3d80&"
import script from "./BazarLogin.vue?vue&type=script&lang=js&"
export * from "./BazarLogin.vue?vue&type=script&lang=js&"
import style0 from "./BazarLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports